import type { DccProfileDto } from "../../types/DccProfileDto";
import type { DccProfileEntity } from "../../types/DccProfileEntity";

export const DccProfileEntityToDto = ({ ...rest }: Readonly<DccProfileEntity>): DccProfileDto => {
    return { ...rest };
};
